// extracted by mini-css-extract-plugin
export default {"main":"FedAutocomplete_main__SQcuA"};